import { removePermissionUrl } from './urls';
import { extractPermissions } from './extractPermissions';
import { doWithToken } from '../keycloak';

export const removeBannerSetPermission = (mediaUrl, uid, permissionId) => {
  try {
    return doWithToken(token => {
      const url = `${mediaUrl}${removePermissionUrl}`;
      return fetch(url, {
        method: 'POST',
        headers: new Headers({
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          'X-NXenrichers.document': 'acls', // to know what permissions are given to the banner-set
        }),
        body: JSON.stringify({
          input: uid, // banner-set uid
          params: {
            id: permissionId, // such as READ_42cdc7e5-cee9-49a9-95f3-dd35f33f97df:Read:true:france@pizza-hut.pizza::
          },
        }),
      })
        .then(res => res.json())
        .then(entry => extractPermissions(entry))
        .catch(e => console.error('error in setting permissions in nuxeo', e));
    });
  } catch (e) {
    console.error('cant set permission in nuxeo', e);
  }
};
